module.exports = __webpack_public_path__ + "img/heavy_menu_hover.22a4a497.svg";